import React from 'react';
import classNames from 'classnames';

class Row extends React.Component {
    render() {
        let {className, children, ...props} = this.props;
        let Comp = this.props.node;

        return (
            <Comp className={classNames('row', className)}
                {...props}>
                {children}
            </Comp>
        );
    }
}

Row.propTypes = {
    node: React.PropTypes.node.isRequired,
    className: React.PropTypes.string,
    children: React.PropTypes.node
};

Row.defaultProps = {node: 'div'};

export default Row;